/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * The person kind.
 * @export
 * @enum {string}
 */
const PersonKind = {
    Unknown: 'Unknown',
    Actor: 'Actor',
    Director: 'Director',
    Composer: 'Composer',
    Writer: 'Writer',
    GuestStar: 'GuestStar',
    Producer: 'Producer',
    Conductor: 'Conductor',
    Lyricist: 'Lyricist',
    Arranger: 'Arranger',
    Engineer: 'Engineer',
    Mixer: 'Mixer',
    Remixer: 'Remixer',
    Creator: 'Creator',
    Artist: 'Artist',
    AlbumArtist: 'AlbumArtist',
    Author: 'Author',
    Illustrator: 'Illustrator',
    Penciller: 'Penciller',
    Inker: 'Inker',
    Colorist: 'Colorist',
    Letterer: 'Letterer',
    CoverArtist: 'CoverArtist',
    Editor: 'Editor',
    Translator: 'Translator'
};

export { PersonKind };
